const COUNTDOWN = {
    COUNTDOWNS: [60, 120, 300, 420, 2700],
    ONE_HOUR: 60 * 60 * 1000
}

export default COUNTDOWN;
